import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import fonts from './_fonts';
import general from './_general';
import MvlGeneralStyles from './_mvl-general';
import MVLFontStyles from './_mvlfonts';


const GlobalStyles = createGlobalStyle`
  ${reset}
  ${({isMVL}) => isMVL ? MVLFontStyles : fonts}
  ${({isMVL}) => isMVL ? MvlGeneralStyles : general}
  
  .highlighted{
 color:#000;
 }
  #onetrust-banner-sdk {
    z-index: 998 !important; //hides the OneTrust CCPA banner behind the "Are you a HCP" modal
  }
    .onetrust-pc-dark-filter {
    z-index: 998 !important;
    backdrop-filter: blur(8px) !important;
    @media only screen and (max-width: 768px) {
    background: none !important;
    background-color: unset !important;
    }
    }

       .bc-iframe, .bc-iframe body, .bc-player-meAxH3mZK_default, .bc-player-meAxH3mZK_default .vjs-poster {
  //  background:transparent !important;
}
`;


export default GlobalStyles;